import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EmailIcon from '@mui/icons-material/Email';
import styles from '@src/components/CampaignLanding/RewardSuccessMessage.module.less';

const RewardSuccessMessage = ({ amount }) => {
  if (!amount || amount <= 0) {
    return null;
  }

  const sanitizedAmount = Number(amount).toFixed(2);

  return (
    <Paper className={styles.rewardSuccessCard} elevation={3}>
      <Box className={styles.iconContainer}>
        <CheckCircleIcon className={styles.checkIcon} />
        <CardGiftcardIcon className={styles.giftIcon} />
      </Box>

      <Typography variant="h5" className={styles.title}>
        Your Submission is Being Approved!
      </Typography>

      <Box className={styles.amountBox}>
        <Typography variant="h3" className={styles.amount}>
          ${sanitizedAmount}
        </Typography>
        <Typography variant="body1" className={styles.amountLabel}>
          Gift Card
        </Typography>
      </Box>

      <Box className={styles.infoSection}>
        <EmailIcon className={styles.emailIcon} />
        <Typography variant="body2" className={styles.infoText}>
          Once approved, you&apos;ll receive your ${sanitizedAmount} gift card via email within 24-48 hours
        </Typography>
      </Box>

      <Box className={styles.thankYouBox}>
        <Typography variant="body1" className={styles.thankYouText}>
          Thank you for your submission! 🎉
        </Typography>
      </Box>
    </Paper>
  );
};

RewardSuccessMessage.propTypes = {
  amount: PropTypes.number.isRequired,
};

export default RewardSuccessMessage;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/RewardSuccessMessage.jsx